/**
 * Analytics helpers for A/B test tracking.
 * Wraps GA4 events with ab_experiment and ab_variant dimensions.
 */

import ReactGA from 'react-ga4';
import { canTrack, sanitizeGaEventParams } from './analytics';

export function sendGa4AbEvent(eventName, params = {}) {
  if (!canTrack()) return;
  ReactGA.event(eventName, sanitizeGaEventParams({
    domain_name: typeof window !== 'undefined' ? window.location.hostname : '',
    ...params,
  }));
}

/**
 * Wrap existing trackViewPromotion to include A/B variant.
 */
export function trackViewPromotionAB(feature, userTier, variant) {
  sendGa4AbEvent('view_promotion', {
    promotion_name: feature || 'general',
    user_tier: userTier,
    ab_experiment: 'paywall_ctr_v1',
    ab_variant: variant,
  });
}

/**
 * Wrap existing trackSelectPromotion to include A/B variant.
 */
export function trackSelectPromotionAB(cta, feature, variant) {
  sendGa4AbEvent('select_promotion', {
    promotion_name: feature || 'general',
    cta,
    ab_experiment: 'paywall_ctr_v1',
    ab_variant: variant,
  });
}

const MAP_PAYWALL_EXPERIMENT = 'map_paywall_v2';
const MAP_PAYWALL_VARIANT = 'preview';

export function trackViewPromotionMapV2(userTier) {
  sendGa4AbEvent('view_promotion', {
    promotion_name: 'map',
    user_tier: userTier,
    ab_experiment: MAP_PAYWALL_EXPERIMENT,
    ab_variant: MAP_PAYWALL_VARIANT,
  });
}

export function trackSelectPromotionMapV2(cta, extra = {}) {
  sendGa4AbEvent('select_promotion', {
    promotion_name: 'map',
    cta,
    ab_experiment: MAP_PAYWALL_EXPERIMENT,
    ab_variant: MAP_PAYWALL_VARIANT,
    ...extra,
  });
}

export function trackMapPaywallExposure() {
  if (typeof sessionStorage === 'undefined') return;
  const sessionKey = `${MAP_PAYWALL_EXPERIMENT}_exposed`;
  if (sessionStorage.getItem(sessionKey)) return;
  sendGa4AbEvent('ab_test_exposure', {
    ab_experiment: MAP_PAYWALL_EXPERIMENT,
    ab_variant: MAP_PAYWALL_VARIANT,
  });
  sessionStorage.setItem(sessionKey, '1');
}
